<template>
    <div class="xl-50 col-lg-5 box-col-5">
        <div class="small-chart-widget chart-widgets-small">
          <div class="card">
            <div class="card-header pb-0">
              <h3>Monthly Sales</h3>
            </div>
            <div class="card-body">
              <div class="chart-container">
                <div class="row">
                  <div class="col-12">
                    <div id="chart-widget8">
                        <apexchart height="315" :options="monthly.options" :series="monthly.series"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
             </div>
          </div>
        </div>
      </div>
      <div class="xl-50 col-lg-7 box-col-7">
        <div class="small-chart-widget chart-widgets-small">
          <div class="card">
            <div class="card-header pb-0">
              <h3>Uses</h3>
            </div>
            <div class="card-body">
              <div class="chart-container">
                <div class="row">
                  <div class="col-12">
                    <div id="chart-widget9">  <apexchart height="315" :options="uses.options" :series="uses.series"></apexchart></div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import wcharts from '../../../data/widgets/charts/wcharts'
export default{
    name: 'monthlyPage',
    data(){
        return{
            monthly: wcharts.MonthlySale,
            uses: wcharts.WidgetsUserChart
        }
    }
}
</script>